
import React, { useState, useEffect, useContext, useRef,useMemo } from "react";
import { Bar, Doughnut, Pie, Line } from 'react-chartjs-2'
import 'chart.piecelabel.js';
import 'chartjs-plugin-datalabels';
import BeatLoader from "react-spinners/BeatLoader";
import Charts from './Charts';
import { v1 as uuidv1 } from 'uuid';
import { DatePicker, Space } from 'antd';
import { Grid, Row, Col } from "react-bootstrap";
import {
  LandingContainer,
  LandingContent,
  LandingItems,
  LandingH1,
  LandingP,
} from '../../views/home/LandingElements';
import { useTranslation } from 'react-i18next';
import moment from "moment";
import { FetchAPI } from "api/fetch";
import { PostAPI } from "api/post.js";
import 'antd/dist/antd.css';
import Tippy from '@tippyjs/react';
import {animateFill} from 'tippy.js';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/shift-away.css';
import "react-datepicker/dist/react-datepicker.css";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { Card } from 'components/Card/Card.jsx';
import Select from 'react-select'
import  MultiSelect from "react-multi-select-component";
import { StatsCard } from "components/StatsCard/StatsCard";
import { MDBCol } from 'mdbreact';
import 'chart.piecelabel.js';
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import 'chartjs-plugin-datalabels';
import './DashBoardStyles.css';
import Cookies from 'universal-cookie';
import Dropdown from "../Dropdown/Dropdown";
import GetSimpleBarGraph from "./GetSimpleBarGraph";
import FullPageLoader from "components/FullPageLoader/FullPageLoader";


const Dashboard = (props) => {

  let [getChartTypes, setGetChartTypes] = useState('')
  const { t, i18n } = useTranslation();
  let [chartTitle, setChartTitle] = useState('Today')
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData?.pageTypes[0].bodyLayout;
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const date = moment();
  let domain = (window.location.hostname).split(/[-.]/);
  let clientName = domain[0].toUpperCase()
  const [dates, setDates] = useState(null);
  const [value, setValue] = useState(null);
  const { RangePicker } = DatePicker;
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [slectedDates, setSelectedDates] = useState('')
  const [calendarfocused, setCalendarFocused] = useState(false)
  let [inventorydataSet,setInventoryDataSet] = useState()
  const [selectedOption, setSelectedOption] = useState('')
  let [dispatchCountPermssion, setDispatchCountPermssion] = useState(false)
  let [productCountPermssion, setProductCountPermssion] = useState(false)
  let [inwardCountPermssion, setInwardCountPermssion] = useState(false)
  let [inventoryCountPermssion, setInventoryCountPermssion] = useState(false)
  let [holdCountPermission, setHoldCountPermission] = useState(false)
  let [scrapCountPermission, setScrapCountPermission] = useState(false)
  let [locationsData, setLocationsData] = useState(null)
  let [customRange, setCustomRange] = useState(false)
  let [presentDay, setPresentDay] = useState(false);
  let [last30Days, setLast30Days] = useState(false);
  let [selectedCardTitle, setSelectedCardTitle] = useState({
    production: false,
    dispatch: false
  });
  let arr = [];
  const canvasRef = useRef(null);
  const cookies = new Cookies();
  let locations,dateArray,count,all_loc,backgroundColor;
  let objLoc = [];
  let dynamicParameters = {
    user_id: cookies.get('user_id'),
    customer_id: cookies.get('customer_id'),
    src_loc_id: cookies.get('userLocation_id'),
    userRole_name: cookies.get('userRole_name'),
    location: 'all',
    from_date: date.format('YYYY-MM-DD'),
    to_date: date.format('YYYY-MM-DD'),
    userLocation_id: cookies.get('userLocation_id'),
  }
  let [prodObj, setProdObj] = useState([])
  let [invObj, setInvObj] = useState([])
  let [dispObj, setDispObj] = useState([])
  let [invenObj, setInvenObj] = useState([])
  let [getProductionCharts, setGetProductionCharts] = useState(null)
  let [inventoryData1, setInventoryData1] = useState([])
  let [getDispatchCharts, setGetDispatchCharts] = useState(null)
  let [getInventoryCharts, setGetInventoryCharts] = useState(null)
  let [getInwardCharts, setGetInwardCharts] = useState(null)
  let [allProductionCharts, setallProductionCharts] = useState(null)
  let [allDispatchCharts, setallDispatchCharts] = useState(null)
  let[allgetInwardCharts, setallgetInwardCharts] = useState(null)
  let [locationResponse, setLocationResponse] = useState([])
  let[allgetInventoryCharts, setallgetInventoryCharts] = useState(null)
  const [selectedOptions, setSelectedOptions] = useState([]);


  useEffect(() => {
    (async () => {
      if (pageLayoutData != 'undefined') {
        let totalParams, location;
        let getURL = pageLayoutData[0].locationEndPoint;
        if (pageLayoutData[0].firstTimeParameters !== null) {
          const firstTimeParameters = pageLayoutData[0].firstTimeParameters;
          totalParams = { ...totalParams, ...firstTimeParameters}
        }
        if (pageLayoutData[0].apiEndPointType === 'GET') {
            totalParams = { ...totalParams, ...dynamicParameters}
            let paramsConverted = new URLSearchParams(totalParams);
            getURL = (`${getURL}?${paramsConverted.toString()}`);
            let responseData = await FetchAPI(getURL);
            if (responseData.status == 200) {
              let responseDataJson = await responseData.json();
              setLocationResponse(responseDataJson.data)
              props.setAdminLocations(responseDataJson.data)
              props.setSelected(responseDataJson.data)
            }
          }
        else {
          totalParams = { ...totalParams, ...dynamicParameters}
          let responseData = await PostAPI(getURL, totalParams);
        }
      }
    })()
  },[pageLayoutData])


  useEffect(() => {
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  }, [globalLoadIndicator]);





  useEffect(() => {
    if(locationResponse !== undefined){
      objLoc = Object.values(locationResponse).reduce((obj,value) => {
        obj.push({value:value.value,label:value.label})
        return obj
    },[])
  }
    setSelectedOptions(objLoc)
  },[locationResponse])

  useEffect(() => {
    if(props.count?.locations?.length === 1){
      setLocationsData(props?.count?.locations && props?.count?.locations[0].value)
    }
    setDispatchCountPermssion(props.count?.DispatchCountPermission === true)
    setProductCountPermssion(props.count?.ProductionCountPermission === true)
    setInwardCountPermssion(props.count?.InwardCountPermission === true)
    setInventoryCountPermssion(props.count?.InventoryCountPermission === true)
    setHoldCountPermission(props.count?.HoldCountPermission === true)
    setScrapCountPermission(props.count?.ScrapCountPermission === true)
  })

  useEffect(() => {
    props.dateFilter({ selectedOption, slectedDates })
  }, [selectedOption, slectedDates])

  Object.keys(props?.count).forEach((el) =>{
    if(el.includes('Permission')){
      arr.push(props?.count[el])
    }
  })

  const productionData = () => {
    let data;
    if (props.count?.productionCountAgainstLocation && props.count?.productionCountAgainstLocation) {
      locations = [];
      count = [];
      dateArray = [];
      backgroundColor = [];
      data = Object.values(props.count?.productionCountAgainstLocation && props.count?.productionCountAgainstLocation)
        .map((value) => {
          if(value.location_name !== null){
          locations.push(value.location_name);
          count.push(value.count);
          dateArray.push(value.date)
          backgroundColor.push(value.backgroundColor)
          return locations, count, dateArray, backgroundColor
          }
        });
    }
    return {
      Locations: locations,
      productionCount: count,
      backgroundColor:backgroundColor,
      dates: dateArray
    }
  }
  let productionDataSet = productionData()



  const dispatchData = () => {
    let data;
    if (props.count?.dispatchCountAgainstLocation && props.count?.dispatchCountAgainstLocation) {
      locations = [];
      count = [];
      dateArray = [];
      backgroundColor = [];
      data = Object.values(props.count?.dispatchCountAgainstLocation && props.count?.dispatchCountAgainstLocation)
        .map((value) => {
          locations.push(value.location_name);
          count.push(value.count);
          dateArray.push(value.date)
          backgroundColor.push(value.backgroundColor)
          return locations, count, dateArray,backgroundColor
        });
    }
    return {
      Locations: locations,
      dispatchCount: count,
      dates: dateArray,
      backgroundColor: backgroundColor
    }
  }
  let dispatchDataSet = dispatchData()

  const inwardData = () => {
    let data;
    if (props.count?.inwardCountAgainstLocation && props.count?.inwardCountAgainstLocation) {
      locations = [];
      count = [];
      dateArray = [];
      backgroundColor = [];
      data = Object.values(props.count?.inwardCountAgainstLocation && props.count?.inwardCountAgainstLocation)
        .map((value) => {
          locations.push(value.location_name);
          count.push(value.count);
          dateArray.push(value.date)
          backgroundColor.push(value.backgroundColor)
          return locations, count, dateArray, backgroundColor
        });
    }
    return {
      Locations: locations,
      inwardCount: count,
      dates: dateArray,
      backgroundColor:backgroundColor,
    }
  }
  let inwardDataSet = inwardData()


  const inventoryDataSet = () => {
    let data;
    if(props.count?.inventoryCountAgainstLocation !== undefined){
      if(props.count?.inventoryCountAgainstLocation.length !== 0){
        locations = [];
        count = [];
        dateArray = [];
        backgroundColor = [];
        data = Object.values(props.count?.inventoryCountAgainstLocation && props.count?.inventoryCountAgainstLocation)
          .map((value) => {
            locations.push(value.location_name);
            count.push(value.count);
            dateArray.push(value.date);
            backgroundColor.push(value.backgroundColor)
            return locations, count, dateArray, backgroundColor
          });
      }
    }

    return {
      Locations: locations,
      inventoryCount: count,
      dates: dateArray,
      backgroundColor: backgroundColor
    }
  }
  let inventoryData = inventoryDataSet()

  if (locations && locations) {
    all_loc = [...locations]
    all_loc.unshift('All')
  }

  const locationsArray = all_loc && all_loc.reduce((locations, value) => {
    locations.push({ value: uuidv1(), label: value });
    return locations;
  }, []);

  function selectedChart(charts) {
    setGetChartTypes(charts)
  }

  const BLOCKED_DATES = [
    moment().add(7, 'days').startOf('M')
  ]

  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const onDateChange = (value, dateString) => {
    setValue(value)
    setSelectedDates(dateString)
    setChartTitle('Date Filter Count');
  }

  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], 'days') > 89;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') > 89;
    return !!tooEarly || !!tooLate;
  };

  let handleIsDayBlocked = (day) => {
    return BLOCKED_DATES.filter((d) => d.isSame(day, 'day')).length > 0;
  }




  const locationData = locationsData !== null && locationsData !== 0
  const productionBarChartData = {
    labels: productionDataSet.Locations,
    datasets: prodObj
  }

  const productionBarChartOptions = {
    title: {
      display: true,
      text: chartTitle,
      fontSize: 18,
    },
    layout: {
      padding: 1
    },
    tooltips:{
      callbacks:{
        label : function(tooltipItem){
          return 'Count ' + Number(tooltipItem.yLabel)
        }
      }
    },
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      display:false,
      position: 'bottom',
      labels: {
        boxWidth: 20,
        padding: 1
      }
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      yAxes: [{
        ticks: {
          color: '#f9f9f9',
          beginAtZero: true
        }
      }],
      xAxes: [{
        ticks: {
          display:false,
          maxRotation:90,
          minRotation:80
        },
        gridLines:{
          offsetGridLines: true
        }
      }]
    },
    plugins: {
      datalabels: {
        display: true,
        color: 'black',
        font: {
          weight: 'bold',
          size: 10,
          maxRotation: 90,
          minRotation: 90
        }
      },
    }
  }

  const dispatchBarChartdata = {
    labels: dispatchDataSet.Locations && dispatchDataSet.Locations,
    datasets: dispObj
  }
  const dispatchBarChartoptions = {
    title: {
      display: true,
      text: chartTitle,
      fontSize: 18,
    },
    layout: {
      padding: 1
    },
    tooltips:{
      callbacks:{
        label : function(tooltipItem){
          return 'Count ' + Number(tooltipItem.yLabel)
        }
      }
    },
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      display: false,
      position: 'bottom',
      labels: {
        boxWidth: 20,
        padding: 1
      }
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      yAxes: [{
        ticks: {
          color: '#f9f9f9',
          beginAtZero: true
        }
      }],
      xAxes: [{
        ticks: {
          display: false
        }
      }]
    },
    plugins: {
      datalabels: {
        display: true,
        color: 'black',
        font: {
          align:'bottom',
          weight: 'bold',
          size: 10
        }
      }
    }
  }



  const inwardBarChartdata = {
    labels: inwardDataSet.Locations && inwardDataSet.Locations,
    datasets: invObj
  }
  
  const inwardBarChartoptions = {
    title: {
      display: true,
      text: chartTitle,
      fontSize: 18,
    },
    tooltips:{
      callbacks:{
        label : function(tooltipItem){
          return 'Count ' + Number(tooltipItem.yLabel)
        }
      }
    },
    layout: {
      padding: 1
    },
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      display: false,
      position: 'bottom',
      labels: {
        boxWidth: 20,
        padding: 1
      }
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      yAxes: [{
        ticks: {
          color: '#f9f9f9',
          beginAtZero: true
        }
      }],
      xAxes: [{
        ticks: {
          display: false
        }
      }]
    },
    plugins: {
      datalabels: {
        display: true,
        color: 'black',
        font: {
          weight: 'bold',
          size: 10
        }
      }
    }
  }




  const inventoryBarChartdata = {
    labels: inventoryData.Locations && inventoryData.Locations,
    datasets: invenObj
  }

  const inventoryBarChartoptions = {
    title: {
      display: true,
    },
    tooltips:{
      callbacks:{
        label : function(tooltipItem){
          return 'Count ' + Number(tooltipItem.yLabel)
        }
      }
    },
    layout: {
      padding: 1
    },
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      display:false,
      position: 'bottom',
      labels: {
        boxWidth: 20,
        padding: 1
      }
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    scales: {
      yAxes: [{
        ticks: {
          color: '#f9f9f9',
          beginAtZero: true
        }
      }],
      xAxes: [{
        ticks: {
          display: false,
          maxRotation:90,
          minRotation:80
        },
        gridLines:{
          offsetGridLines: true
        }
      }]
    },
    plugins: {
      datalabels: {
        display: true,
        color: 'black',
        font: {
          weight: 'bold',
          size: 10
        }
      }
    }
  }


  const LineData = {
    labels: locations,
    datasets: [{
      label: locations && locations[0],
      data: count,
      fill: false,
      tension: 0.4,
      backgroundColor: ['rgba(255, 99, 132, 0.7)', 'rgba(75, 192, 192, 0.7)', 'rgba(53, 162, 235, 0.7)'],
      borderColor: ['rgba(255, 99, 132, 1)', 'rgba(75, 192, 192, 1)', 'rgba(53, 162, 235, 0.7)'],
      borderWidth: 3,
    },
    {
      label: locations && locations[1],
      backgroundColor: 'rgb(75, 192, 192)',
    },
    {
      label: locations && locations[2],
      backgroundColor: 'rgb(53, 162, 235)',
    }
    ]

  }

  const LineChartOPtions = {
    title: {
      display: true,
      text: chartTitle,
      fontSize: 18,
      padding: 1,
      lineHeight: 1.2
    },
    layout: {
      padding: 1
    },
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      display: 'bottom'
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    }
  }

  const PieChartoptions = {
    maintainAspectRatio: true,
    responsive: true,
    title: {
      display: true,
      text: chartTitle,
      fontSize: 18,
      padding: 1,
      lineHeight: 1.2
    },
    legend: {
      position: 'bottom'
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
      animation: {
        animateScale: true,
        animateRotate: true
    },
    plugins: {
      datalabels: {
        display: true,
        color: 'white',
        font: {
          weight: 'bold',
        }
      }
    }
  }

  const productionCharts = (charts) => {
    switch (charts) {
      case 'ProductionBar':
        return (
          <Bar
            height='200%'
            data={productionBarChartData}
            options={productionBarChartOptions}>
          </Bar>
        )
      case 'ProductionPie':
        return (
          <Pie
            height='200%'
            data={LineData}
            options={PieChartoptions}>
          </Pie>
        )
      case 'ProductionDoughnut':
        return (
          <Doughnut
            height='200%'
            data={LineData}
            options={productionBarChartOptions}>
          </Doughnut>
        )
      case 'ProductionLine':
        return (
          <Line
            height='200%'
            data={LineData}
            options={LineChartOPtions}>
          </Line>
        )
      default:
        return (
          <>
          {props.isLoader ? 
           <div style={{ textAlign: 'center', marginTop: '22%', position:'absolute', marginLeft:'40%' }}>
           <BeatLoader />
       </div> :
          <Bar
            height='200%'
            data={productionBarChartData}
            options={productionBarChartOptions}>
          </Bar>}
          </>
        )
    }
  }

  const dispatchCharts = (charts) => {
    switch (charts) {
      case 'DispatchBar':
        return (
          <Bar
            height='200%'
            data={dispatchBarChartdata}
            options={dispatchBarChartoptions}>
          </Bar>
        )
      case 'DispatchPie':
        return (
          <Pie
            height='200%'
            data={LineData}
            options={PieChartoptions}>
          </Pie>
        )
      case 'DispatchDoughnut':
        return (
          <Doughnut
            height='200%'
            data={LineData}
            options={PieChartoptions}>
          </Doughnut>
        )
      case 'DispatchLine':
        return (
          <Line
            height='200%'
            data={LineData}
            options={LineChartOPtions}>
          </Line>
        )
      default:
        return (
          <>
          {props.isLoader ? 
           <div style={{ textAlign: 'center', marginTop: '22%', position:'absolute', marginLeft:'40%' }}>
           <BeatLoader />
       </div> :
          <Bar
            height='200%'
            data={dispatchBarChartdata}
            options={dispatchBarChartoptions}>
          </Bar>}
          </>
        )
    }
  }

  const inwardCharts = (charts) => {
    switch (charts) {
      case 'InwardBar':
        return (
          <Bar
            height='200%'
            data={inwardBarChartdata}
            options={inwardBarChartoptions}>
          </Bar>
        )
      case 'InwardPie':
        return (
          <Pie
            height='200%'
            data={LineData}
            options={PieChartoptions}>
          </Pie>
        )
      case 'InwardDoughnut':
        return (
          <Doughnut
            height='200%'
            data={LineData}
            options={PieChartoptions}>
          </Doughnut>
        )
      case 'InwardLine':
        return (
          <Line
            height='200%'
            data={LineData}
            options={LineChartOPtions}>
          </Line>
        )
      default:
        return (
          <>
          {props.isLoader ? 
            <div style={{ textAlign: 'center', marginTop: '22%', position:'absolute', marginLeft:'40%' }}>
            <BeatLoader />
        </div> :
          <Bar
            height='200%'
            data={inwardBarChartdata}
            options={inwardBarChartoptions}>
          </Bar>}
          </>
        )
    }
  } 

  

  const inventoryCharts = (charts) => {
    switch (charts) {
      case 'Bar':
        return (
          <Bar
            height='200%'
            data={inwardBarChartdata}
            options={inwardBarChartoptions}>
          </Bar>
        )
      case 'Pie':
        return (
          <Pie
            height='200%'
            data={LineData}
            options={PieChartoptions}>
          </Pie>
        )
      case 'Doughnut':
        return (
          <Doughnut
            height='200%'
            data={LineData}
            options={PieChartoptions}>
          </Doughnut>
        )
      case 'Line':
        return (
          <Line
            height='200%'
            data={LineData}
            options={LineChartOPtions}>
          </Line>
        )
      default:
        return (
          <Bar
            height='200%'
            data={inwardBarChartdata}
            options={inwardBarChartoptions}>
          </Bar>
        )
    }
  }



  const filteredOptions = [
    { value: 'today', label: 'Today' },
    { value: '30 days', label: 'Last 30 Days' },
    { value: '90 days', label: 'Last 90 Days' },
    { value: 'custom', label: 'Custom Range' }
  ]

  const handleDateFilter = (e) => {
    setSelectedOption(e.value)
    setSelectedDates('')
    setCustomRange(false)
    switch (e.value) {
      case '30 days':
        setChartTitle(e.label)
        break;
      case '90 days':
        setChartTitle(e.label)
        break;
      case 'today':
        setChartTitle(e.label);
        break;
      case 'custom':
        setCustomRange(true)
    }
  };

  const handleLocationsFilter = (selectedOptionValue) => {
      setLocationsData(selectedOptionValue)
  };


  useEffect(() => {
    let OBJ
    if (props.count.hasOwnProperty('productionCountAgainstLocation')) {
      OBJ = Object.entries(props.count?.productionCountAgainstLocation).reduce((obj, value) => {
        obj.push({ label: value[1].location_name, backgroundColor: value[1].backgroundColor })
        return obj
      }, [])
      let arr = OBJ.shift()
      OBJ.unshift({ label: productionDataSet.Locations[0], data: productionDataSet.productionCount, backgroundColor: productionDataSet.backgroundColor })
      setProdObj(OBJ)
    }
    if (props.count.hasOwnProperty('dispatchCountAgainstLocation')) {
      OBJ = Object.entries(props.count?.dispatchCountAgainstLocation).reduce((obj, value) => {
        obj.push({ label: value[1].location_name, backgroundColor: value[1].backgroundColor })
        return obj
      }, [])
      let arr = OBJ.shift()
      OBJ.unshift({ label: dispatchDataSet.Locations[0], data: dispatchDataSet.dispatchCount, backgroundColor: dispatchDataSet.backgroundColor })
      setDispObj(OBJ)
    } 
    if (props.count.hasOwnProperty('inwardCountAgainstLocation')) {
      OBJ = Object.entries(props.count?.inwardCountAgainstLocation).reduce((obj, value) => {
        obj.push({ label: value[1].location_name, backgroundColor: value[1].backgroundColor })
        return obj
      }, [])
      let arr = OBJ.shift()
      OBJ.unshift({ label: inwardDataSet.Locations[0], data: inwardDataSet.inwardCount, backgroundColor: inwardDataSet.backgroundColor })
      setInvObj(OBJ)
    } 
    if (props.count.hasOwnProperty('inventoryCountAgainstLocation')) {
      OBJ = Object.entries(props.count?.inventoryCountAgainstLocation).reduce((obj, value) => {
        obj.push({ label: value[1].location_name, backgroundColor: value[1].backgroundColor })
        return obj
      }, [])
      let arr = OBJ.shift()
      OBJ.unshift({ label: inventoryData.Locations[0], data: inventoryData.inventoryCount, backgroundColor: inventoryData.backgroundColor })
      setInvenObj(OBJ)
    }
  }, [props.count])


  const customValueRenderer = (selected, _options) => {
      if(selected.length === locationResponse.length){
        return "All Locations are selected"
      }else{
      return selected.length ? selected.map(({ label }) => label): "No Locations Selected";
      }
  };

  function onChange(value) {
    setSelectedOptions(value)
    props.setSelected(value)
  }

  const filterOptions = (options, filter) => {
    if (!filter) {
      return options;
    }
    const filteredOptions = options.filter((obj => {
        return obj.label.toLowerCase().includes(filter.toLowerCase())
    }))
    return filteredOptions;
  };

  return (
    (JSON.stringify(props?.count) !== JSON.stringify({}) ?
      (arr.some((el) => el === true) ?
        <div>
          <div class="container-fluid">
            <div class="align-items-center ml-2 ml-lg-0">
              <div class='row'>
                <a href='#!' class="mr-2 navbar-brand" className='font-weight-bold' style={{ color: 'black', marginInlineStart: '14px', fontSize: '20px' }}>
                  <strong>DASHBOARD</strong>
                </a>
                <div className="drop-downs">
                  <div class="col-md-6">
                    <></>
                  </div>
                  <div class="col-md-3" style={{ marginTop: "-34px" }}>
                    <Select
                      closeMenuOnSelect={true}
                      options={filteredOptions}
                      defaultValue={filteredOptions[0]}
                      onChange={handleDateFilter}
                    />
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3" style={{ marginTop: "-34px" }}>
                    {locationResponse.length === 1 ?
                      <Select className="select"
                        value={locationResponse[0]}
                        isDisabled={true}
                      /> :
                      <MultiSelect
                        options={locationResponse}
                        value={selectedOptions}
                        valueRenderer={customValueRenderer}
                        onChange={onChange}
                        filterOptions={filterOptions}
                        labelledBy="Select"
                      />
                    }
                  </div>
                  {customRange ?
                    <div class="col-xs-12 col-sm-6 col-md-3" style={{ marginInlineStart: "38em", marginTop: "2px", marginBottom: "5px" }}>
                      <RangePicker
                        size={'large'}
                        value={dates || value}
                        onChange={onDateChange}
                        inputReadOnly  = {true}
                        defaultPickerValue={moment()}
                        onOpenChange={onOpenChange}
                        onCalendarChange={(val) => setDates(val)}/>
                    </div> : ''}
                </div>
              </div>
            </div>
          </div>

          <div class="content">
            <Grid fluid>
              <Row>
                {productCountPermssion ?
                  <Col lg={3} sm={6}>
                    <StatsCard
                      bigIcon={
                        <i className="fas fa-network-wired text-primary" />}
                      statsText="Production"
                      statsValue={props.count?.production_count && props.count?.production_count == null ? '- -' : props.count?.production_count}
                    />
                  </Col> : ''}
                {inventoryCountPermssion ?
                  <Col lg={3} sm={6}>
                    <StatsCard
                      elements='true'
                      infoIcon={<i style={{ display: 'flex', marginInlineStart: "216px", alignItems: 'flex-end', color: 'rgb(255, 99, 71, 1)', position:'relative', bottom:'4px' }} class="fa fa-info-circle fa-6" aria-hidden="true"></i>}
                      bigIcon={<i className="fa-solid fa-boxes-stacked text-secondary" />}
                      statsText="Live Inventory"
                      statsValue={props.count?.inventory_count && props.count?.inventory_count == null ? '- -' : props.count?.inventory_count}
                    />
                  </Col> : ''}
                {dispatchCountPermssion ?
                  <Col lg={3} sm={6}>
                    <StatsCard
                      bigIcon={<i className="fa fa-truck text-success" />}
                      statsText="Dispatch"
                      statsValue={props.count?.dispatch_count && props.count?.dispatch_count == null ? '- -' : props.count?.dispatch_count}
                    />
                  </Col> : ""}
                {inwardCountPermssion ?
                  <Col lg={3} sm={6}>
                    <StatsCard
                      bigIcon={<i className="fa-solid fa-minimize text-warning" />}
                      statsText="Inward"
                      statsValue={props.count?.inward_count && props.count?.inward_count == null ? '- -' : props.count?.inward_count}
                    />
                  </Col> : ""}
                {holdCountPermission ?
                  <Col lg={3} sm={6}>
                    <StatsCard
                      bigIcon={<i className="fa-solid fa-cart-flatbed text-warning" />}
                      statsText="Hold"
                      statsValue={props.count?.hold_count && props.count?.hold_count == null ? '- -' : props.count?.hold_count}
                    />
                  </Col> : ""}
                {scrapCountPermission ?
                  <Col lg={3} sm={6}>
                    <StatsCard
                      bigIcon={<i className="fa-solid fa-trash text-danger" />}
                      statsText="Scrap"
                      statsValue={props.count?.scrap_count && props.count?.scrap_count == null ? '- -' : props.count?.scrap_count}
                    />
                  </Col> : ''}
                { }
              </Row>
              <Row>
                {productCountPermssion ?
                  <Col md={6} style={{ marginTop: '-18px' }}>
                    <Card
                      id="chartHours"
                      filter='true'
                      drop={<Dropdown selectedChart={selectedChart} setGetProductionCharts={setGetProductionCharts} data={locations} count={props.count.production_count} title='Production' setSelectedCardTitle={setSelectedCardTitle} setallProductionCharts={setallProductionCharts} />}
                      title="Production"
                      content={
                        <div id='row' style={{ height: "235px" }}>
                          {selectedOptions.length === 1 ?
                            <div style={{ marginInlineStart: '-3rem', marginTop: '-37px' }}>
                              <Charts chartTypes={getChartTypes} isLoader={props.isLoader} getProductionCharts={getProductionCharts} data={props.count} title='Production' date={selectedOption} selecedTitle={selectedCardTitle} />
                            </div>
                            :
                            <GetSimpleBarGraph
                              allProductionCharts={allProductionCharts}
                              isLoader={props.isLoader}
                              chartTypes={getChartTypes}
                              getProductionCharts={getProductionCharts}
                              title='Production'
                              count={props.count.production_count}
                              productionBarChartData={productionBarChartData}
                              productionBarChartOptions={productionBarChartOptions}
                              LineData={LineData}
                              PieChartoptions={PieChartoptions}
                              LineChartOPtions={LineChartOPtions} />}
                        </div>
                      }
                    />
                  </Col> : ''}
                  {inventoryCountPermssion ?
                  <Col md={6} style={{ marginTop: '-18px' }}>
                    <Card
                      id="chartHours"
                      filter='true'
                      elements='true'
                      drop={<Dropdown selectedChart={selectedChart} setGetInventoryCharts={setGetInventoryCharts} count={props.count.inventory_count} data={locations} title='Inventory' setSelectedCardTitle={setSelectedCardTitle} setallgetInventoryCharts={setallgetInventoryCharts} />}
                      title="Live Inventory"
                      infoIcon={<i style={{ display: 'flex', marginInlineStart: "145px", fontSize: '17px', alignItems: 'flex-end', color: 'rgb(255, 99, 71, 1)' }} class="fa fa-info-circle fa-6" aria-hidden="true"></i>}
                      content={
                        <div id='row' style={{ height: "235px" }}>
                          {selectedOptions.length === 1 ?
                            <div style={{ marginInlineStart: '-3rem', marginTop: '-37px' }}>
                              <Charts chartTypes={getChartTypes} isLoader={props.isLoader} getInventoryCharts={getInventoryCharts} data={props.count} title='Inventory' date={selectedOption} setSelectedCardTitle={selectedCardTitle} setallgetInventoryCharts={setallgetInventoryCharts} />
                            </div>
                            :
                            <GetSimpleBarGraph
                              allgetInventoryCharts={allgetInventoryCharts}
                              isLoader={props.isLoader}
                              chartTypes={getChartTypes}
                              getInventoryCharts={getInventoryCharts}
                              title='Inventory'
                              count={props.count.inventory_count}
                              inventoryBarChartdata={inventoryBarChartdata}
                              inventoryBarChartoptions={inventoryBarChartoptions}
                              LineData={LineData}
                              PieChartoptions={PieChartoptions}
                              LineChartOPtions={LineChartOPtions}
                            />}
                        </div>
                      }
                    />
                  </Col> : ''}
                  </Row>
                  <br />
                  <Row>
                {dispatchCountPermssion ?
                  <Col md={6} style={{ marginTop: '-18px' }}>
                    <Card
                      id="chartHours"
                      filter='true'
                      drop={<Dropdown selectedChart={selectedChart} count={props.count.dispatch_count} setGetDispatchCharts={setGetDispatchCharts} data={locations} title='Dispatch' setSelectedCardTitle={setSelectedCardTitle} setallDispatchCharts={setallDispatchCharts} />}
                      title="Dispatch"
                      content={
                        <div id='row' style={{ height: "235px" }}>
                          {selectedOptions.length === 1 ?
                            <div style={{ marginInlineStart: '-3rem', marginTop: '-37px' }}>
                              <Charts chartTypes={getChartTypes} isLoader={props.isLoader} getDispatchCharts={getDispatchCharts} data={props.count} title='Dispatch' date={selectedOption} setSelectedCardTitle={selectedCardTitle} setallDispatchCharts={setallDispatchCharts} />
                            </div>
                            :
                            <GetSimpleBarGraph
                              allDispatchCharts={allDispatchCharts}
                              isLoader={props.isLoader}
                              chartTypes={getChartTypes}
                              getDispatchCharts={getDispatchCharts}
                              title='Dispatch'
                              count={props.count.dispatch_count}
                              dispatchBarChartdata={dispatchBarChartdata}
                              dispatchBarChartoptions={dispatchBarChartoptions}
                              LineData={LineData}
                              PieChartoptions={PieChartoptions}
                              LineChartOPtions={LineChartOPtions} />}
                        </div>
                      }
                    />
                  </Col> : ''}
                {inwardCountPermssion ?
                  <Col md={6} style={{ marginTop: '-18px' }}>
                    <Card
                      id="chartHours"
                      filter='true'
                      drop={<Dropdown selectedChart={selectedChart} count={props.count.inward_count} setGetInwardCharts={setGetInwardCharts} data={locations} title='Inward' setSelectedCardTitle={setSelectedCardTitle} setallgetInwardCharts={setallgetInwardCharts} />}
                      title="Inward"
                      content={
                        <div id='row' style={{ height: "235px" }}>
                          {selectedOptions.length === 1 ?
                            <div style={{ marginInlineStart: '-3rem', marginTop: '-37px' }}>
                              <Charts chartTypes={getChartTypes} isLoader={props.isLoader} getInwardCharts={getInwardCharts} data={props.count} title='Inward' date={selectedOption} setSelectedCardTitle={selectedCardTitle} setallgetInwardCharts={setallgetInwardCharts} />
                            </div>
                            :
                            <GetSimpleBarGraph
                              allgetInwardCharts={allgetInwardCharts}
                              isLoader={props.isLoader}
                              chartTypes={getChartTypes}
                              getInwardCharts={getInwardCharts}
                              title='Inward'
                              count={props.count.inward_count}
                              inwardBarChartdata={inwardBarChartdata}
                              inwardBarChartoptions={inwardBarChartoptions}
                              LineData={LineData}
                              PieChartoptions={PieChartoptions}
                              LineChartOPtions={LineChartOPtions}
                            />}
                        </div>
                      }
                    />
                  </Col> : ''}
              </Row>
            </Grid>
          </div>
        </div> : 
        <LandingContainer>
          <LandingItems>
            <LandingH1>{t("welcome")} eSeal</LandingH1>
            <LandingP>{clientName}</LandingP>
          </LandingItems>
        </LandingContainer>)
      : <FullPageLoader />
    )
  )
}

export default Dashboard;